// Constants
import { cardShadow } from "Constants/ColourConstants";
import { BUTTON_BORDER_RADIUS } from "Constants/theme";

// Material UI
import { alpha } from "@mui/material/styles";

export const styles = {
  navBar: {
    p: 0.5,
    px: { xs: 0.5, sm: 1 },
    width: "98%",
    minWidth: "300px",
    justifyContent: "space-between",
    backgroundColor: "background.paper",
    borderRadius: BUTTON_BORDER_RADIUS,
    boxShadow: cardShadow,
    boxSizing: "border-box",
  },
  menuItemNoHover: {
    cursor: "default",
    "&:hover": { backgroundColor: "transparent" },
  },
  modeButtonGroup: (theme) => ({
    "& .MuiButtonGroup-grouped": {
      minHeight: 36,
    },
    "& .MuiButtonGroup-grouped.MuiButton-outlined": {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
    "& .MuiButtonGroup-grouped.MuiButton-outlined:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.06),
    },
  }),
};
